const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-donut', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			init: {
				type: Object,
				required: true
			},
			chartData: {
				type: Object,
				required: true
			},
			chartRequest: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartdonut-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			if (this.chartData && this.chartData.Values) {
				Vue.nextTick(() => {
					this.setupChart();
				});
			}
		},
		methods: {
			setupChart: function () {
				var colors = window.getChartColors(this.chartData.Values.length);
				var data = Array.prototype.map.call(this.chartData.Values, (el, i) => ({
					y: el.Percentage,
					count: window.groupDigits(el.Number),
					name: el.Dimension1,
					color: colors[i]
				}));

				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'pie'
					},
					plotOptions: {
						pie: {
							borderColor: null,
							borderWidth: 2,
							allowPointSelect: false,
							shadow: false,
							center: ['50%', '50%'],
							dataLabels: {
								connectorWidth: 1,
								distance: 15
							},
							states: {
								hover: {
									brightness: 0,
									halo: {
										opacity: 1,
										borderWidth: 0,
										borderColor: null
									}
								}
							}
						}
					},
					tooltip: {
						formatter: function () {
							console.log(this);
							return `${this.series.name}<br/><span style="color:${this.color};">${this.key}</span>: <strong>${this.y}%</strong></span><br/><em>size: ${this.point.count}</em>`;
						}
					},
					series: [
						{
							name: this.init.Name,
							data: data,
							size: '70%',
							innerSize: '55%',
							dataLabels: {
								formatter: function () {
									return `${this.point.name}<br/>${this.point.y}%<br/>${this.point.count}`;
								},
								color: '#ffffff'
							},
							events: {
								click: function (e) {
									console.log(e);
									console.log(e.point.series.chart.getSelectedPoints());
									e.point.select(!e.point.selected, false);
								}
							}
						}
					]
				}));
				this.$emit('chartReady', this.chart);
			}
		}
	})
})();
